import { render, staticRenderFns } from "./smallAdd.vue?vue&type=template&id=f13f2f68"
import script from "./smallAdd.vue?vue&type=script&lang=js"
export * from "./smallAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13f2f68')) {
      api.createRecord('f13f2f68', component.options)
    } else {
      api.reload('f13f2f68', component.options)
    }
    module.hot.accept("./smallAdd.vue?vue&type=template&id=f13f2f68", function () {
      api.rerender('f13f2f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/majorSmallType/smallAdd.vue"
export default component.exports